import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import { heroSliderData } from "../../constants";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const LogoTicker = () => {
  const tickerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 } // Trigger when 20% of the element is visible
    );

    if (tickerRef.current) {
      observer.observe(tickerRef.current);
    }

    return () => {
      if (tickerRef.current) {
        observer.unobserve(tickerRef.current);
      }
    };
  }, []);

  const settings = {
    infinite: true,
    speed: 3000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: isVisible, // Autoplay only when visible
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  };

  return (
    <motion.div
      ref={tickerRef}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 2, ease: "easeOut", delay: 2 }}
      className="flex flex-col gap-2 border-y-[1px] border-white h-8"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut", delay: 3 }}
      >
        <div
          className="z-10 border-r border-red-500 absolute flex items-center justify-center w-auto px-2 h-10 
                bg-black text-white rounded-md shadow-[inset_3px_3px_6px_rgba(255,255,255,0.1),inset_-3px_-3px_6px_rgba(0,0,0,0.7)]"
        >
          <h1
            className="w-full text-xs font-semibold whitespace-nowrap flex items-center justify-center h-full 
                 text-gray-200 drop-shadow-[1px_1px_1px_rgba(255,255,255,0.2)]"
          >
            {t("our_clients")}
          </h1>
        </div>

        <Slider {...settings}>
          {heroSliderData.map((item, index) => (
            <div key={index} className="align-middle bg-black px-8 py-[1px]">
              <div className="">
                <img
                  src={item.logo_image}
                  alt={`Logo ${index}`}
                  className="h-10 w-auto object-contain shadow-sm mx-auto"
                />
              </div>
            </div>
          ))}
        </Slider>
      </motion.div>
    </motion.div>
  );
};

export default LogoTicker;
